<template>
  <CalendarWrapper @changed="updateCalendar" @created="updateCalendar">
    <template #default="{ data, actions }">
      <div class="flex-1 flex min-h-full">
        <component
          :is="current"
          :calendar="data.calendar"
          :loading="loading"
          :tasks="filteredTasks"
          :campaigns="campaigns"
          :production-orders="filteredProductionOrders"
          :assigned-to-me.sync="assignedToMe"
          @set-weekly-view="setCurrentWeekly"
          @set-monthly-view="setCurrentMonthly"
          @set-month="actions.setMonth"
          @prev-month="actions.prevMonth"
          @next-month="actions.nextMonth"
          @prev-week="actions.prevWeek"
          @next-week="actions.nextWeek"
          @today="actions.setDate"
          @set-date="changeDate(arguments[0], actions.setDate)"
          @refresh="updateCalendar"
        />
      </div>
    </template>
  </CalendarWrapper>
</template>

<script>
import CalendarWrapper from './Wrapper';
import Monthly from './Monthly.vue';
import Weekly from './Weekly.vue';

const MONTHLY = 'monthly';
const WEEKLY = 'weekly';

export default {
  name: 'Calendar',

  components: { CalendarWrapper, Monthly, Weekly },

  props: {
    tasks: {
      type: Array,
      default: () => [],
    },
    campaigns: {
      type: Array,
      default: () => [],
    },
    productionOrders: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    current: MONTHLY,
    assignedToMe: false,
  }),

  computed: {
    filteredTasks() {
      return this.tasks.filter((task) => {
        if (!this.assignedToMe) {
          return true;
        }

        // task is for contact
        if (task.contact) {
          const contact =
            typeof task.contact === 'string'
              ? this.$store.state.entities.contacts.byId[task.contact]
              : task.contact;

          return contact && contact.assigneeUuid && contact.assigneeUuid === this.$user.id;
        }

        if (task.contactRequest) {
          const contactRequest =
            typeof task.contactRequest === 'string'
              ? this.$store.state.entities.contactRequests.byId[task.contactRequest]
              : task.contactRequest;

          return contactRequest && this.$user.id === contactRequest.user_id;
        }

        // task is for project
        if (task.project) {
          return task.userAssignedId === this.$user.id;
        }

        return false;
      });
    },
    filteredProductionOrders() {
      return this.productionOrders.filter((productionOrder) => {
        if (!this.assignedToMe) return true;
        if (!productionOrder.orderItems || !productionOrder.orderItems.length) return false;
        if (!productionOrder.assigneeUuid) return false;
        if (productionOrder.assigneeUuid !== this.$user.id) return false;
        return true;
      });
    },
  },

  methods: {
    setCurrentWeekly() {
      this.current = WEEKLY;
    },
    setCurrentMonthly() {
      this.current = MONTHLY;
    },
    changeDate(date, next) {
      next(date);
      if (this.current !== WEEKLY) {
        this.setCurrentWeekly();
      }
    },
    updateCalendar(calendar) {
      const periodFrom = calendar.meta.firstCalendarDate.format('YYYY-MM-DD');

      const periodTo = calendar.meta.lastCalendarDate.format('YYYY-MM-DD');

      this.$emit('update-calendar', {
        period: `${periodFrom},${periodTo}`,
      });
    },
  },
};
</script>
